import { CultureInfo } from '../culture-info.model';
import { CultureInfoDe } from './de';

/**
 * @ignore
 */
export const CultureInfoDeDE: CultureInfo = {
  name: 'de-DE',
  displayName: 'German (Germany)',
  iso3LanguageCode: 'deu',
  iso2LanguageCode: 'de',
  ietfLanguageTag: 'de-DE',
  parent: CultureInfoDe
};
